import xss from "xss";
import isHTML from "./isHTML";

export default function sanitize(possiblyUnsafeValue) {
  const attrWhitelist = ["class", "id"];

  if (isHTML(possiblyUnsafeValue)) {
    const options = {
      onTagAttr: function (tag, name, value, isWhiteAttr) {
        if (attrWhitelist.includes(name)) {
          return `${name}="${xss(value)}"`;
        }
      },
    };

    return xss(possiblyUnsafeValue, options);
  }

  return possiblyUnsafeValue;
}
